var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pop-panel',{attrs:{"name":'修改手机号'}},[_c(_vm.currentPage,{tag:"component",attrs:{"form":_vm.form},on:{"change":_vm.changeHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }